import { render, staticRenderFns } from "./pBottom.vue?vue&type=template&id=f5e6c6f8&"
import script from "./pBottom.vue?vue&type=script&lang=js&"
export * from "./pBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "1d630c42"
  
)

export default component.exports